import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'

import { 
    Layout,
    Col, 
    Row,
    Space,
    Table,
    Button,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { 
  ArrowBack,
} from '@mui/icons-material';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
// import { formatDate } from '../../Utils/Common';
import { SeeAttachment } from '../../Components/SeeAttachment';
import { ProductOutlined } from '@ant-design/icons';
import { formatDate } from '../../Utils/Common';

const MoveOutTenants = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [isLoading, setIsLoading] = useState(false);
  const [attachmentsData, setAttachmentsData] = useState([]);
  const [tenantData, setTenantData] = useState([])
  const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;
  const columns = [
    {
      title: 'Property',
      dataIndex: 'property_name',
      key: 'property_name',
    },
    {
      title: 'Rental Unit',
      dataIndex: 'rental_unit_name',
      key: 'rental_unit_name',
    },
    {
      title: 'Contract Signed Date',
      dataIndex: 'contract_sign_date',
      key: 'contract_sign_date',
      render: (contract_sign_date) => formatDate(contract_sign_date)
    },
    {
      title: 'Contract End Date',
      dataIndex: 'contract_end_date',
      key: 'contract_end_date',
      render: (contract_end_date) => formatDate(contract_end_date)
    },
    {
      title: 'Move Out Date',
      dataIndex: 'move_out_date',
      key: 'move_out_date',
      render: (move_out_date) => formatDate(move_out_date)
    },
  ];  
  const columns2 = [
    {
      title: 'Date Added',
      dataIndex: 'added_on',
      key: 'added_on',
      width: '30%',
      render: (amount) => formatDate(amount),
    },
    {
      title: 'Attachments',
      dataIndex: 'link',
      key: 'link',
    },
  ];  
  
  async function fetchMoveOutData  () {
    setIsLoading(true)
    const response = await UseGetRequest("tenants/get_moved_out",{tenant_id: id});
    if (response?.data) {
      let attachment = response?.data?.data?.attachments?.map((file) => ({
        ...file,
        link: (
          <SeeAttachment
            attachments={[
              { file_url: file.file_url, file_name: file.file_name },
            ]}
          />
        ),
      }))
      setTenantData(response?.data?.data);
      setAttachmentsData(attachment)
    } else {
      setTenantData([])
    }
    setIsLoading(false);
  }
  useEffect(() => {
    fetchMoveOutData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout className='page'>
        <Navbar navKey={'unit_contract_nav'}/>
        <Layout className='content-container overflow-tenant'>
          <Row className='custom-padding responsive-inline responsive-tab-inline'>
            <Col span={12} className='header-container'>
              <Space>
                <ArrowBack className='cursor' onClick={() => navigate(-1)}/>
                MOVE OUT TENANTS
              </Space>
            </Col>
            <Col span={12} align='right' className='pt-2'>
              <Button
                onClick={() => navigate('/tenant/print-soa/move-out/' + tenantData.id)}
                type='primary'
                className='btn-header'
              >
                Print Billing Invoice
              </Button>
            </Col>
          </Row>
          <Row className='custom-padding responsive-inline responsive-tab-inline'>
            <Col span={24} className='p-2'>
                <Row className='mb-2'>
                    <Col span={19} align="left">
                        <Space>
                            <div>
                                Name :
                            </div>
                            <div>
                                {tenantData?.trade_name}
                            </div>
                        </Space>
                    </Col>
                    <Col span={5} align="left">
                        <Space>
                            <div>
                                Renter No.
                            </div>
                            <div>
                                {tenantData?.renter_id}
                            </div>
                        </Space>
                    </Col>
                </Row>
                <Row className='mb-2'>
                    <Col span={19} align="left">
                        <Space>
                            <div>
                                Address :
                            </div>
                            <div>
                                {tenantData?.business_address}
                            </div>
                        </Space>
                    </Col>
                    <Col span={5} align="left">
                        <Space>
                          <div>
                            TIN :
                          </div>
                          <div>
                            {tenantData?.tin}
                          </div>
                        </Space>
                    </Col>
                </Row>
                <Row className='mb-2'>
                    <Col span={19} align="left">
                        <Space>
                            <div>
                                Email:
                            </div>
                            <div>
                                {tenantData?.renter_email}
                            </div>
                        </Space>
                    </Col>
                    <Col span={5} align="left">
                        <Space>
                          <div>
                            Contact Number :
                          </div>
                          <div>
                            {tenantData?.contact_no}
                          </div>
                        </Space>
                    </Col>
                </Row>
            </Col>
          </Row>
          <Row className='page-content mb-2'>
            <Col span={24} className='responsive-overflow-auto'>
              <Table 
                columns={columns} 
                dataSource={[tenantData]} 
                pagination={false}
                loading={{
                  indicator: customSpinner, // Use custom spinner
                  spinning: isLoading, // Set spinning based on loading state
                }}
              />
            </Col>
          </Row>
          <Row className='mx-4 mb-5'>
            <Col span={24} className=''>
              <Table 
                columns={columns2} 
                dataSource={attachmentsData} 
                pagination={false}
                loading={{
                indicator: customSpinner, // Use custom spinner
                spinning: isLoading, // Set spinning based on loading state
                }}
              />
            </Col>
          </Row>
      </Layout>
    </Layout>
  )
}

export default MoveOutTenants
